import { render, staticRenderFns } from "./Git.vue?vue&type=template&id=2fced011&scoped=true"
import script from "./Git.vue?vue&type=script&lang=js"
export * from "./Git.vue?vue&type=script&lang=js"
import style0 from "./Git.vue?vue&type=style&index=0&id=2fced011&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fced011",
  null
  
)

export default component.exports